exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-title {\n  text-align: center;\n  margin-bottom: 20px; }\n\n.dialog-content {\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 5px; }\n\n.dialog-actions {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin-top: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/projetosinfo/projetosinfo.component.scss
// module id = ../../../../../src/app/components/dialog/projetosinfo/projetosinfo.component.scss
// module chunks = main